/** Presentation only: keep the original point array for track building/editing. */
export function visibleTravelPoints(points, itemTypeId) {
    var _a;
    const rows = points.map(point => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const value = point;
        const raw = (_b = (_a = value === null || value === void 0 ? void 0 : value.raw) !== null && _a !== void 0 ? _a : value) !== null && _b !== void 0 ? _b : {};
        const data = { ...raw, ...raw.properties };
        const id = String((_e = (_d = (_c = data.point_travel_id) !== null && _c !== void 0 ? _c : data.id) !== null && _d !== void 0 ? _d : value === null || value === void 0 ? void 0 : value.id) !== null && _e !== void 0 ? _e : '');
        const parent = (_f = data.linked_start_id) !== null && _f !== void 0 ? _f : data.linked_point_id;
        return { point, data, id, parent: parent == null ? '' : String(parent),
            type: Number((_j = (_h = (_g = data.item_type_id) !== null && _g !== void 0 ? _g : data.parent_item_type_id) !== null && _h !== void 0 ? _h : value === null || value === void 0 ? void 0 : value.itemTypeId) !== null && _j !== void 0 ? _j : itemTypeId),
            order: Number((_m = (_l = (_k = data.point_order) !== null && _k !== void 0 ? _k : data.order) !== null && _l !== void 0 ? _l : data.sort_order) !== null && _m !== void 0 ? _m : 0) };
    });
    // Old downloaded trips predate the explicit server flag. Infer their linked
    // movement interiors, retaining the start and last stop even across plan days.
    const groups = new Map();
    for (const row of rows) {
        const root = row.parent || row.id;
        if (!root)
            continue;
        const group = (_a = groups.get(root)) !== null && _a !== void 0 ? _a : [];
        group.push(row);
        groups.set(root, group);
    }
    const hidden = new Set();
    for (const group of groups.values()) {
        if (group.length < 3 || !group.some(row => row.type === 1 || row.type === 2))
            continue;
        group.sort((a, b) => Number(Boolean(a.parent)) - Number(Boolean(b.parent)) || a.order - b.order);
        for (const row of group.slice(1, -1))
            hidden.add(row.point);
    }
    return rows.filter(row => ![true, 1, 'true', '1'].includes(row.data.is_route_waypoint)
        && !hidden.has(row.point)).map(row => row.point);
}
/** Restore route-only coordinates into the editor when a road track stores
 * only its two real points. Never expand the complete GPX track into stops. */
export function movementEditorPoints(points) {
    var _a, _b, _c, _d, _e, _f;
    if (points.length !== 2)
        return [...points];
    const waypoints = (_d = (_b = (_a = points[0].route_waypoints) !== null && _a !== void 0 ? _a : points[1].route_waypoints) !== null && _b !== void 0 ? _b : (_c = points[0].coordinates) === null || _c === void 0 ? void 0 : _c.route_waypoints) !== null && _d !== void 0 ? _d : (_e = points[1].coordinates) === null || _e === void 0 ? void 0 : _e.route_waypoints;
    if (!Array.isArray(waypoints) || waypoints.length < 3)
        return [...points];
    const coordinates = waypoints.map(value => Array.isArray(value) ? value : value === null || value === void 0 ? void 0 : value.coordinates);
    if (coordinates.some(value => !Array.isArray(value) || !Number.isFinite(value[0]) || !Number.isFinite(value[1])))
        return [...points];
    const start = points[0];
    const root = (_f = start.point_travel_id) !== null && _f !== void 0 ? _f : start.id;
    return [start, ...coordinates.slice(1, -1).map((coordinate, index) => {
            var _a;
            return ({
                point_travel_id: `route-waypoint:${root}:${index}`, linked_start_id: root,
                item_travel_id: (_a = start.item_travel_id) !== null && _a !== void 0 ? _a : start.item_id, item_type_id: start.item_type_id,
                point_type_id: start.point_type_id, is_route_waypoint: true, point_order: index + 1,
                coordinates: { type: 'Point', coordinates: [...coordinate] },
                place: '', description: '', date: null, time: null, images: [],
            });
        }), points[1]];
}
/** General-map movements may return their routing coordinates separately from
 * the two real endpoints. Use these only for routing and the editor's map. */
export function userMovementRoutePoints(move) {
    var _a, _b;
    const points = Array.isArray(move === null || move === void 0 ? void 0 : move.points) && move.points.length >= 2
        ? move.points : [move === null || move === void 0 ? void 0 : move.start, move === null || move === void 0 ? void 0 : move.finish].filter(Boolean);
    if (points.length !== 2)
        return [...points];
    const waypoints = (_a = move === null || move === void 0 ? void 0 : move.route_waypoints) !== null && _a !== void 0 ? _a : (_b = move === null || move === void 0 ? void 0 : move.route) === null || _b === void 0 ? void 0 : _b.route_waypoints;
    return movementEditorPoints(waypoints ? [{ ...points[0], route_waypoints: waypoints }, points[1]] : points);
}
